import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TargetDevice } from 'app/campaign/campaign.model';
import { WidgetEditorDataService } from 'app/campaign/widget-editor-data.service';
import { EditingDevice, WidgetDeviceView } from 'app/campaign/widgets.model';

@Component({
  selector: 'app-device-buttons',
  templateUrl: './device-buttons.component.html',
  styleUrls: ['./device-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DeviceButtonsComponent {
  public DeviceViewEnums = WidgetDeviceView;
  public currentDeviceView: WidgetDeviceView = WidgetDeviceView.Desktop;
  // Native-app campaigns preview on a tablet, not a desktop — the non-mobile view is relabelled "Tablet".
  public isNativeApp = false;

  @Output() changedCurrentDeviceView = new EventEmitter();
  constructor(public widgetEditorDataService: WidgetEditorDataService) {
    this.widgetEditorDataService.currentDeviceViewBS.pipe(takeUntilDestroyed()).subscribe((deviceView) => {
      this.currentDeviceView = deviceView;
    });
    this.widgetEditorDataService.campaignBS.pipe(takeUntilDestroyed()).subscribe((campaign) => {
      this.isNativeApp = campaign?.targetDevice === TargetDevice.NativeApp;
    });
  }

  public changeCurrentDeviceView(deviceView: WidgetDeviceView): void {
    this.currentDeviceView = deviceView;
    this.changedCurrentDeviceView.emit(deviceView);
    if (deviceView === WidgetDeviceView.Mobile) {
      this.widgetEditorDataService.currentEditingDeviceBS.next(EditingDevice.Mobile);
    }
  }
}
